import { render } from "./TrashCanOutline.vue?vue&type=template&id=3daa0f14"
import script from "./TrashCanOutline.vue?vue&type=script&lang=js"
export * from "./TrashCanOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__